<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('form_label_productName') || '产品名称'" prop="productName">
            <el-input
              v-model="formData.productName"
              :disabled="disabled"
              clearable
              :placeholder="$l('form_label_pl_productName') || '请输入产品名称'"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_styleCount') || '款数'" prop="styleCount">
            <el-input-number
              v-model="formData.styleCount"
              :min="1"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_styleCount') || '请输入款数'"
              style="width:100%"
              :controls="false"
              :max="999999999"
              :precision="0"
              :step="1"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_orderTotalQty') || '订单总数量'">
            <el-input
              v-model="formData.orderTotalQty"
              :disabled="disabled"
              style="width:100%"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_shouldCheckQty') || '应查数量'" prop="shouldCheckQty">
            <el-input-number
              v-model="formData.shouldCheckQty"
              :min="1"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_shouldCheckQty') || '请输入应查数量'"
              style="width:100%"
              :controls="false"
              :max="999999999"
              :precision="0"
              :step="1"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_actualCheckQty') || '实查数量'">
            <el-input
              v-model="formData.actualCheckQty"
              :disabled="disabled"
              style="width:100%"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_signSample') || '签样'" prop="signSample">
            <dict-select
              size="mini"
              v-model="formData.signSample"
              url="/sys/common/dict/system"
              :body="{ dictType: 'DF_INSPECTION_PRODUCT_SIGN_SAMPLE' }"
              filterable
              clearable
              :placeholder="$l('form_label_pl_signSample') || '请选择签样'"
              style="width:100%"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item :label="$l('form_label_signSampleRemark') || '签样说明'">
            <el-input
              v-model="formData.signSampleRemark"
              :disabled="disabled"
              maxlength="300"
              :placeholder="$l('form_label_pl_signSampleRemark') || '请输入签样说明'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_inspectionCategory') || '检验类别'" prop="inspectionCategory">
            <br />
            <dict-radio-group
              size="mini"
              v-model="formData.inspectionCategory"
              url="/sys/common/dict/system"
              :body="{ dictType: 'DF_INSPECTION_PRODUCT_INSPECTION_CATEGORY' }"
              :disabled="disabled"
              style="width:100%"
              @change="handleInspectionCategoryChange"
            >
            </dict-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item :label="$l('form_label_inspectionStandardList') || '检验标准'" prop="inspectionStandardList">
            <br />
            <InspectionStandardCheckbox
              v-model="formData.inspectionStandardList"
              size="mini"
              :disabled="disabled"
              url="/sys/common/dict/system"
              :body="{ dictType: 'DF_INSPECTION_PRODUCT_INSPECTION_STANDARD' }"
              @change="handleInspectionStandardChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" style="text-align: right;">
          <div style="height: 100%;" class="mt-4" v-if="!disabled">
            <el-button type="primary" size="mini" @click="save">
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <GoodsTable
      ref="goodsTable"
      class="mt-2"
      :disabled="disabled"
      :baseInfo="baseInfo"
      :inspectionProductCode="inspectionProductCode"
      @reload="reload"
    />
    <el-row :gutter="10">
      <el-col :span="12">
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :title="$l('form_label_inspectionMaterialDoc') || '验货资料'"
          :inspectionApplyCode="inspectionApplyCode"
          :fileType="'1'"
      /></el-col>
      <el-col :span="12">
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :title="$l('form_label_inspectionTestReport') || '测试报告'"
          :inspectionApplyCode="inspectionApplyCode"
          :fileType="'2'"
      /></el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GoodsTable from './goods-table/index.vue'
import DocTable from './doc-table/index.vue'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import DictRadioGroup from '@/views/factory/components/dict-radio-group'
import InspectionStandardCheckbox from './inspection-standard-checkbox.vue'

export default {
  mixins: [EditLoading],
  components: {
    GoodsTable,
    DocTable,
    DictRadioGroup,
    InspectionStandardCheckbox,
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => ({}),
    },
    disabled: { type: Boolean, default: true },
    inspectionApplyCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { inspectionCategory: '', inspectionStandardList: [] },
      inspectionProductCode: '',
      rules: {
        productName: [
          { required: true, message: this.$l('form_label_pl_productName') || '请输入产品名称', trigger: 'blur' },
        ],
        styleCount: [
          { required: true, message: this.$l('form_label_pl_styleCount') || '请输入款数', trigger: 'blur' },
        ],
        shouldCheckQty: [
          { required: true, message: this.$l('form_label_pl_shouldCheckQty') || '请输入应查数量', trigger: 'blur' },
        ],
        signSample: [
          { required: true, message: this.$l('form_label_pl_signSample') || '请选择签样', trigger: 'change' },
        ],
        inspectionCategory: [
          {
            required: true,
            message: this.$l('form_label_pl_inspectionCategory') || '请选择检验类别',
            trigger: 'change',
          },
        ],
        inspectionStandardList: [
          {
            type: 'array',
            required: true,
            message: this.$l('form_label_pl_inspectionStandardList') || '请选择检验标准',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  watch: {},
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.inspectionApplyCode) return
      const data = await this.$api
        .dfInspectionProductDetailApi({
          inspectionApplyCode: this.inspectionApplyCode,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
      if (!data || !data.inspectionProductCode) return
      const { inspectionStandard = '', inspectionProductCode = '' } = data
      const inspectionStandardList =
        inspectionStandard?.split(',').filter(Boolean) || []

      this.formData = {
        ...data,
        inspectionStandardList,
      }
      this.inspectionProductCode = inspectionProductCode
      await this.$refs.goodsTable.setTableData(this.inspectionProductCode)
    },
    reload() {
      this.getData()
      this.$emit('setOrderNos')
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const { inspectionStandardList } = this.formData

      const inspectionStandard = inspectionStandardList
        .filter(Boolean)
        .join(',')

      const res = await this.$api
        .dfInspectionProductSaveApi({
          ...this.formData,
          inspectionApplyCode: this.inspectionApplyCode,
          inspectionStandard,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.inspectionProductCode = body
      this.getData()
    },
    async handleInspectionStandardChange(val = []) {
      this.formData = {
        ...this.formData,
        inspectionStandardList: val,
      }
      if (val.length > 0) {
        this.$refs.form.clearValidate('inspectionStandardList')
      } else {
        this.$refs.form.validateField('inspectionStandardList')
      }
    },
    async handleInspectionCategoryChange(val) {
      this.formData.inspectionCategory = val
      this.$refs.form.clearValidate('inspectionCategory')
    },
  },
}
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0;
}

::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>
